import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useToast } from '../ui/Toast';

const Navbar = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const { toast } = useToast();

    const handleLogout = () => {
        logout();
        toast.info('You have been logged out successfully.', { title: 'Goodbye!' });
        navigate('/');
    };

    return (
        <nav className="fixed w-full z-50 bg-cyber-black/80 backdrop-blur-md border-b border-gray-800 overflow-hidden">
            <div className="max-w-7xl mx-auto px-2 sm:px-4 md:px-6 lg:px-8">
                <div className="flex justify-between h-16 items-center gap-2 min-w-0">
                    <Link
                        to="/"
                        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                        className="flex-shrink-0 flex items-center cursor-pointer min-w-0 overflow-hidden"
                    >
                        <span className="text-lg sm:text-xl md:text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-neon-blue to-neon-purple font-orbitron tracking-wider drop-shadow-lg truncate">
                            VectorShift
                        </span>
                    </Link>
                    <div className="flex items-center space-x-1 sm:space-x-2 md:space-x-4 flex-shrink-0">
                        {user ? (
                            <>
                                <Link to="/dashboard" className="text-gray-300 hover:text-neon-blue font-medium transition-colors font-rajdhani whitespace-nowrap text-xs sm:text-sm md:text-base">
                                    Dashboard
                                </Link>
                                <button
                                    onClick={handleLogout}
                                    className="px-2 sm:px-3 md:px-4 py-1.5 sm:py-2 rounded-md text-xs sm:text-sm font-medium text-white bg-gray-900 border border-gray-700 hover:bg-gray-800 hover:border-gray-600 transition-colors font-rajdhani whitespace-nowrap"
                                >
                                    Logout
                                </button>
                            </>
                        ) : (
                            <>
                                <Link to="/auth" className="text-gray-300 hover:text-neon-blue font-medium transition-colors font-rajdhani whitespace-nowrap text-xs sm:text-sm md:text-base">
                                    Sign In
                                </Link>
                                <Link
                                    to="/auth?mode=signup"
                                    className="px-2 sm:px-3 md:px-4 py-1.5 sm:py-2 rounded-md text-xs sm:text-sm font-medium text-black bg-neon-blue hover:bg-neon-blue/80 transition-colors shadow-[0_0_15px_rgba(0,243,255,0.4)] font-rajdhani font-bold whitespace-nowrap"
                                >
                                    Get Started
                                </Link>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
